import { types, Instance } from 'mobx-state-tree';
const { model, string, array } = types;

export const ExplorerHistoryModel = model('ExplorerHistoryModel', {
  base: string,
  baseNodeId: string,
  parentNodeId: string,
  expandedNodeIds: array(string),
});

export type IExplorerHistoryModel = Instance<typeof ExplorerHistoryModel>;
